<template>
  <!-- 开发建设单位 -->
  <div class="mechanismComp">
    <div class="mechanismSelect">
      <div class="head">
        <!-- 标题 -->
        <p style="margin-bottom:0px">选择居委会</p>
        <i class="el-icon-close" @click="tipHide"></i>
      </div>
      <div class="housManageNav">
        <label class="ft14 col-33 mar-l mecName1">机构代码：</label>
        <div class="inp">
          <el-input v-model="numInp" placeholder="请输入" size="mini"></el-input>
        </div>
        <label class="ft14 col-33 mar-l mecName">居委会名称：</label>
        <div class="inp">
          <el-input v-model="nameInp" placeholder="请输入" size="mini"></el-input>
        </div>
        <ps-search @click="query"></ps-search>
      </div>
      <div class="dataList">
        <el-table
          highlight-current-row
          @cell-dblclick="handleCurrentChange"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          height="280"
        >
          <el-table-column
            type="index"
            label="序号"
            v-bind:index="indexMethod"
            width="60"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <slot></slot>
        </el-table>
      </div>
      <div class="housManageFoot ub ub-pe ub-ac">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="pageChange"
            :current-page="currentPage"
            :page-sizes="[20, 40, 60, 100]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- <div class="mask"></div> -->
  </div>
</template>
<script>
import nationalRegion from "@/utils/nationalRegion";
export default {
  data() {
    return {
      total: 0, //总页
      currentPage: 1, //当前页
      pageSize: 20,
      numInp: "",
      nameInp: "",
      propertyVal: "", //选中的物业区域
      table: "机构",
      tableData: [],
      loading: true,
      nationalRegion: nationalRegion
    };
  },
  props: ["dataList"],
  watch: {
    dataList: {
      handler: function() {
        if (this.dataList) {
          this.loading = false;
          this.total = this.dataList.length;
          this.tableData = this.dataList.slice(
            this.pageSize * (this.currentPage - 1),
            this.pageSize * this.currentPage
          );
        }
      },
      deep: true
    }
  },
  created() {
    this.total = this.dataList.length;
    this.tableData = this.dataList.slice(
      this.pageSize * (this.currentPage - 1),
      this.pageSize * this.currentPage
    );
  },
  mounted() {
    let dom = document.querySelector(".mechanismSelect");
    // dom.addEventListener('mouseleave',()=>{
    //   this.$store.state.mechanism=false;
    // });
    this.addEvent();
    if (document.body.clientWidth - this.getOffsetLeft(dom) < dom.clientWidth) {
      dom.style.left =
        document.body.clientWidth -
        this.getOffsetLeft(dom) -
        dom.clientWidth -
        50 +
        "px";
    }
  },
  methods: {
    getOffsetLeft(obj) {
      var tmp = obj.offsetLeft;
      var val = obj.offsetParent;
      while (val !== null) {
        tmp += val.offsetLeft;
        val = val.offsetParent;
      }
      return tmp;
    },
    //确定事件
    handelSure() {
      this.$store.state.neighborhoodCommittee = false;
      if (this.propertyVal) {
        this.$emit("propertyVal", this.propertyVal);
      }
    },
    //关闭弹窗
    tipHide() {
      this.$store.state.neighborhoodCommittee = false;
    },
    //移动关闭弹窗
    moveOut() {},
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.tableData = this.dataList.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    //控制每页大小
    handleSizeChange(val) {
      this.pageSize = val;
      this.tableData = this.dataList.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    indexMethod(index) {
      return index + 1 + (this.currentPage - 1) * this.pageSize;
    },
    //选取事件
    handleCurrentChange(val) {
      this.$emit("propertyVal", val);
      this.$store.state.neighborhoodCommittee = false;
    },
    //查询功能
    query() {
      this.loading = true;
      const queryParam = {
        numInp: this.numInp,
        nameInp: this.nameInp
      };
      this.$emit("mecQueryHandle", queryParam);
    },
    leaveHandle() {
      this.$store.state.neighborhoodCommittee = false;
    },
    // 移除鼠标移出监听
    removeEvent() {
      let dom = document.querySelector(".mechanismSelect");
      dom.removeEventListener("mouseleave", this.leaveHandle);
    },
    // 添加事件监听
    addEvent() {
      let dom = document.querySelector(".mechanismSelect");
      dom.addEventListener("mouseleave", this.leaveHandle);
    }
  }
};
</script>
<style lang='scss'>
.mechanismComp {
  .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
  .housManageFoot {
    height: 40px;
    background: #ebebeb;
    .pagination {
      margin: 0;
      height: 30px;
      .el-input__inner {
        height: 28px;
        line-height: 28px;
      }
      .el-input,
      .el-input--mini {
        height: 28px;
        width: 100px !important;
      }
      .el-pagination__editor {
        width: 46px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.mechanismComp {
  height: 100%;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    background: #000;
    opacity: 0.5;
    height: 100%;
    width: 100%;
    z-index: 9;
  }
  .mechanismSelect {
    position: absolute;
    top: 80px;
    left: 0;
    background: #fff;
    border: 1px solid #ccc;
    width: 700px;
    height: 402px;
    z-index: 9;
    .head {
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: space-between;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      padding: 0 20px;
      align-items: center;
      .el-icon-close {
        font-weight: 600;
      }
    }
    .housManageNav {
      height: 40px;
      line-height: 40px;
      display: flex;
      background: #f3f5f9;
      border-bottom: 1px solid #ccc;
      align-items: center;
      .mecName {
        min-width: 100px;
        margin-bottom: 0;
      }
      .mecName {
        min-width: 70px;
        margin-bottom: 0;
      }
      .el-button {
        height: 34px;
        margin-left: 20px;
      }
    }
    // .dataList {
    //   height: 280px;
    //   overflow-y: scroll;
    //   &::-webkit-scrollbar {
    //     display: none;
    //   }
    // }
    .housManageFoot {
      height: 40px;
      background: #ebebeb;
      .el-input__inner {
        height: 28px;
        line-height: 28px;
      }
    }
  }
}
</style>

